import styled from "styled-components";
import LoanDashboardMinimal from "../../../components/elements/frame/FrameView";

export const Frame = () => {
  return (
    <Wrapper data-aos="fade-up" data-aos-delay="2500" data-aos-duration="1500">
      <FrameWrapper className="flexCenter container p20">
        <div className="frame p10 r20 border">
          <div className="r15 border hidden">
            <LoanDashboardMinimal />
          </div>
        </div>
      </FrameWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 20px 0;
  background: linear-gradient(to bottom, transparent 0%, #cbcbcb 100%);
  mask-image: linear-gradient(183deg, black 80%, transparent 100%);

  @media (max-width: 960px) {
    overflow: hidden;
  }
`;

const FrameWrapper = styled.div`
  .border {
    border: 1px solid #e0e0e0;
  }
  .frame {
    background: linear-gradient(135deg, #939393 0%, #d8d8d8 100%);
  }

  @media (max-width: 960px) {
    width: 1080px;
    height: 450px;
    scale: 0.6;
    transform: translateX(-350px);
  }
`;
